import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { PlaneSendIcon } from '@/components/icons/plane-send';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';

import { Agreement } from './agreement';
import { OpeningRow } from './opening-row';

export function Summary() {
  const { formatCurrency } = useCurrencySymbol();
  const { totalBudget, isSubmitting, selectedOpeningIds } =
    useJobPostingContext();

  return (
    <div className="border-fx-neutral-200 mb-2 flex w-full flex-1 flex-col items-start gap-6 overflow-hidden rounded-lg border bg-white p-4 shadow-sm">
      <Typography variant="h4">
        <FormattedMessage
          defaultMessage="Post campaign"
          description="Job posting summary title"
        />
      </Typography>

      <div className="w-full flex-1 overflow-y-auto">
        {/* Opening rows */}
        <ul className="flex flex-col gap-4">
          {selectedOpeningIds.map(openingId => (
            <OpeningRow key={openingId} openingId={openingId} />
          ))}
        </ul>
      </div>

      <div className="flex w-full flex-col items-start gap-2">
        <Separator className="mb-1" />

        {/* Total amount and post button */}
        <div className="flex w-full items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            {/* Total label */}
            <Typography variant="medium2" className="!text-fx-neutral-600">
              <FormattedMessage
                defaultMessage="Total"
                description="Total budget for all channels"
              />
            </Typography>

            {/* Invoice payment disclaimer */}
            {totalBudget > 0 && (
              <Typography
                variant="body1"
                className="text-fx-neutral-400 italic"
              >
                <FormattedMessage
                  defaultMessage="This amount will be paid via invoice"
                  description="Invoice payment disclaimer"
                />
              </Typography>
            )}
          </div>

          <div className="flex items-center gap-4">
            {/* Total amount */}
            <Typography variant="h3" className="!text-fx-neutral-800">
              {formatCurrency(totalBudget)}
            </Typography>

            {/* Post button */}
            <Button type="submit" className="mx-auto" disabled={isSubmitting}>
              {isSubmitting ? (
                <Loader2 className="animate-spin" />
              ) : (
                <PlaneSendIcon className="text-white" />
              )}
              <FormattedMessage
                defaultMessage="Post Job"
                description="Button to post the campaign"
              />
            </Button>
          </div>
        </div>

        <Agreement />
      </div>
    </div>
  );
}
